module.exports = __webpack_public_path__ + "img/iconBussinessSandMoisture.a71686a8.svg";